import { setFineType, setInfringement } from "./fine/fineActions";
import { setRefreshToken, setToken, setUser } from "./auth/authActions";

import store from ".";

export const logout = (noRedirect: boolean) => {
  store.dispatch(setUser(null));
  store.dispatch(setToken(null));
  store.dispatch(setRefreshToken(null));

  if (!noRedirect) {
    window.location.replace("/");
    store.dispatch(setInfringement(null));
    store.dispatch(setFineType(null));
    localStorage.clear();
  }
};
